import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/pages/Header';
import Main from './components/pages/Main';
import Footer from './components/pages/Footer';
import ReleaseNote from './components/docs/ReleaseNote';
import Manual from './components/docs/Manual';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/releasenote" element={<ReleaseNote />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
